<template>
  <div :class="'pt-16 md:p-32'">
    <div :class="'flex flex-col items-center justify-center bg-white p-12'">
      <img alt="img" :src="require('@/assets/img/sketches/nerConfirmation.svg')" class="md:w-3/5 my-4" />
      <p :class="'my-4 text-center text-lg'">
        Thank you for submitting your information. Because this is a request to add a new employer, you will receive an update via email in 2 - 4 business days. We appreciate your interest and will get back to you as soon as possible!
      </p>
      <button @click="redirectTo()" :class="button">
        Explore Other Loan Options
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ner-submitted',
  computed: {
    button() {
      if (this.$store.state.isNerIndustryVivaLoan) return 'hidden'

      return 'w-310 btn base-button btn-primary p-2 rounded my-4'
    },
  },
  methods: {
    redirectTo() {
      const link = this.getExternalLoanLink()
      window.location.href = link
    },
    getExternalLoanLink() {
      /**
       * This is a computed because in the future we might add
       * specific params to customize the loan links for users
       */
      return 'http://o1.qnsr.com/cgi/r?;n=203;c=1681890;s=32978;x=7936;f=202301031132330;u=j;z=TIMESTAMP;subid=USERNAME;AFFID=unsupportedIndustry'
    }
  }
}
</script>
